import { GeneralAPI } from '../apis/GeneralAPI'
import { first } from 'lodash'
import Header from '../components/Header'
import HeroBanner from '../components/RealEstateInvestor/HeroBanner'
import BrandsCarousel from '../components/BrandsCarousel'
import WhyDirectMail from '../components/RealEstateInvestor/WhyDirectMail'
import OurExpertise from '../components/RealEstateInvestor/OurExpertise'
import Products from '../components/RealEstateInvestor/Products'
import VideoReviews from '../components/VideoReviews'
import Testimonials from '../components/Testimonials'
import TransformRealEstateJourney from '../components/TransformRealEstateJourney'
import Footer from '../components/Footer'
import DividerShape from '../components/SwitchToUs/DividerShape'
import ClientSuccess from '../components/SwitchToUs/ClientSuccess'

export default function SwitchToUs({ products, reviews }) {
    return (
        <div>
            <Header />
            <HeroBanner />
            <BrandsCarousel />
            <WhyDirectMail />
            <DividerShape />
            <Products products={products} />
            <OurExpertise />
            <div className="container m-auto mb-16">
                <div className="mx-8 space-y-5">
                    <h3 className="olm-gradient-text text-[22px] leading-[25px] md:text-[30px] md:leading-[45px] text-center font-bold">
                        <span>1 out 5 of the top real estate </span>
                        <br className="block md:hidden" />
                        <span>investors use direct mail</span>
                    </h3>
                    <h3 className="font-bold text-center text-[25px] leading-[30px] md:text-[55px] md:leading-[64.57px] ">
                        But don’t take our word for it,
                        <br />
                        <span className="olm-gradient-text">
                            hear it from them
                        </span>
                    </h3>
                    <VideoReviews reviews={reviews} />
                    <Testimonials reviews={reviews} />
                </div>
            </div>
            <ClientSuccess />
            <TransformRealEstateJourney coupon="REAL10" discount="10" />
            <Footer></Footer>
        </div>
    )
}

export async function getStaticProps() {
    const { acf: reviewsACF } = first(await GeneralAPI.getPageBySlug('reviews'))
    const reviews = reviewsACF?.reviews?.length > 0 ? reviewsACF.reviews : []

    const products = await GeneralAPI.getACFProductsPage()

    return {
        props: {
            products,
            reviews,
        },
    }
}
